import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  isCanceled: boolean;
};

const EmploymentCancellationBar = ({ isCanceled }: Props) => {
  const { t } = useTranslation();

  if (!isCanceled) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#FF9600",
        padding: "4px 24px 4px 24px",
        fontSize: "14px",
        margin: "0px -16px 12px -16px",
      }}
    >
      {t("talentProfile:employmentIsCancelled")}
    </Box>
  );
};

export default EmploymentCancellationBar;
